import React from "react";
import FbLogo from "../images/facebook.png";
import SpotifyLogo from "../images/spotify.png";
import EmailLogo from "../images/email.png";
import InstagramLogo from "../images/instagram.png";
import YouTubeLogo from "../images/youtube.png";
import TidalLogo from "../images/tidal.png";
import BandcampLogo from "../images/bandcamp.png";
import { FooterStyle } from "../styled";
import { useLanguage } from "../i18n/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();
  const a = t.footer;

  return (
    <FooterStyle>
      <a href="https://alinen.bandcamp.com/" target="_blank" rel="noreferrer">
        <img className="some-icon" alt={a.bandcamp} src={BandcampLogo} />{" "}
      </a>
      <a href="https://facebook.com/alinenband" target="_blank" rel="noreferrer">
        <img className="some-icon" alt={a.facebook} src={FbLogo} />{" "}
      </a>
      <a href="https://tidal.com/browse/artist/31184358?u" target="_blank" rel="noreferrer">
        <img className="some-icon" alt={a.tidal} src={TidalLogo} />{" "}
      </a>
      <a
        href="https://open.spotify.com/artist/4U47OP3gdgWtX8NeZAPAVn"
        target="_blank"
        rel="noreferrer"
      >
        <img className="some-icon" alt={a.spotify} src={SpotifyLogo} />{" "}
      </a>
      <a href="https://www.instagram.com/alinenband/" target="_blank" rel="noreferrer">
        <img className="some-icon" alt={a.instagram} src={InstagramLogo} />{" "}
      </a>
      <a href="https://www.youtube.com/@alinen5776" target="_blank" rel="noreferrer">
        <img className="some-icon" alt={a.youtube} src={YouTubeLogo} />{" "}
      </a>
      <a href="mailto:alinenofficial@gmail.com">
        <img className="some-icon" alt={a.email} src={EmailLogo} />{" "}
      </a>
    </FooterStyle>
  );
};

export default Footer;
